import { WorkflowVisualization } from "./workflow-vis.model";
import { WorkflowConnectionWrapper } from "./workflow-connection-wrapper.model";
import { BaseModel } from "../base.model";

export class WorkflowItem extends BaseModel {             
    Order: number;
    VisualizationData: WorkflowVisualization;    
    ClientId: string;  
    // workflow connections that are coming into node
    IncomingConnections: WorkflowConnectionWrapper;
    // workflow connections that are going out of node
    OutgoingConnections: WorkflowConnectionWrapper;

    // props for action item    
    ActionName: string;
    ProviderFullName: string;
    ProvidingType: string;
    ActionUrl: string;
    InputModel: any;
    OutputModel: any;       
    
    // props for conditional item
    //workflowIfTrue: Workflow;
    //workflowIfFalse: Workflow;

    
    private static tempIdsList: any[] = [];
     
     constructor(name:string, id:number, providerFullName:string, inputModel:any, outputModel:any, visualization: WorkflowVisualization, order: number, clientId: string, version: string){                          
        super();
        this.ActionName = name;          
        this.Id = id;          
        this.InputModel = inputModel;
        this.OutputModel = outputModel;
        this.VisualizationData = visualization;
        this.Order = order;
        this.ClientId = clientId;
        this.Version = version;
     }     


     public static mapItem(item: any): WorkflowItem {
         
        if(item != null && typeof item != "undefined"){        
            return new WorkflowItem(item.ActionName, item.Id, item.ProviderFullName, item.InputModel, item.OutputModel, item.Visualization, item.Order, item.ClientId, item.Version);
        }        
        return null;
    }
    
}



